import { sendCustomError } from '@otto-ec/global-resources/apm';

export class ExternalJsLoader {
    public static load(source: string): Promise<void> {
        return new Promise(function (resolve, reject) {
            const timeout = 5000;
            let newScriptElement: HTMLScriptElement | null = document.createElement('script');

            const timeoutTimer = setTimeout(function () {
                if (newScriptElement) {
                    newScriptElement.onload = null;
                }
                newScriptElement = null;

                sendCustomError('product', new Error('ajaxError - could not load script'), {
                    // TODO: this was replaced with error message
                    // messageType: 'ajaxError - could not load script',
                    url: source,
                    timeout: timeout,
                });

                reject(Error('ajaxError - could not load script'));
            }, timeout);

            newScriptElement.async = true;
            newScriptElement.onload = () => {
                if (newScriptElement) {
                    newScriptElement.onload = null;
                    newScriptElement = null;

                    clearTimeout(timeoutTimer);
                    resolve();
                }
            };
            newScriptElement.src = source;
            const firstScriptElement = document.getElementsByTagName('script')[0];
            firstScriptElement.parentNode?.insertBefore(newScriptElement, firstScriptElement);
        });
    }
}
